// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.12.4
//   protoc               unknown
// source: qonto/account_management/users/firstparty/v2/get_user.proto

/* oxlint-disable */
import { ApiUser } from "./user";

/** Request message for GetUser (me endpoint). */
export interface ApiGetUserRequest {
}

/** Response message for retrieving the current user. */
export interface ApiGetUserResponse {
  /** The user data. */
  readonly user: ApiUser | null;
}

export const ApiGetUserRequest: MessageFns<ApiGetUserRequest> = {
  fromJSON(_: any): ApiGetUserRequest {
    return {};
  },

  toJSON(_: ApiGetUserRequest): unknown {
    const obj: any = {};
    return obj;
  },
};

export const ApiGetUserResponse: MessageFns<ApiGetUserResponse> = {
  fromJSON(object: any): ApiGetUserResponse {
    return { user: isSet(object.user) ? ApiUser.fromJSON(object.user) : null };
  },

  toJSON(message: ApiGetUserResponse): unknown {
    const obj: any = {};
    if (message.user !== undefined && message.user !== null) {
      obj.user = ApiUser.toJSON(message.user);
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
